import { Pie } from 'vue-chartjs'

export default {
  extends: Pie,
  props: {
    data: Object,
    options: Object,
    height: String,
    width: String,
    maintainAspectRatio: Boolean
  },
  mounted () {
    this.renderChart(this.data, this.options, this.height, this.width, this.maintainAspectRatio)
  },
  watch: {
    'data' (to, from) {
      this.renderChart(this.data, this.options, this.height, this.width, this.maintainAspectRatio)
    }
  }
}
